/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Janak's Portfolio",
  description:
    "Full Stack Developer specializing in React.js, Next.js, Node.js, NestJS, and TypeScript. Built AI-powered lending platforms, FinTech solutions, SaaS products, logistics systems, and enterprise applications. Skilled in AWS, Azure, MongoDB, MySQL, Docker, and scalable API development.",
  og: {
    title: "Janak Koradiya Portfolio",
    type: "website",
    url: "https://janak-koradiya.netlify.app/",
  },
};

//Home Page
const greeting = {
  title: "Janak Koradiya",
  logo_name: "JanakKoradiya",
  nickname: "Full Stack developer",
  subTitle:
    "Full Stack Developer with 4+ years of experience building scalable SaaS, FinTech, AI-powered, and enterprise applications using React.js, Next.js, Node.js, NestJS, TypeScript, MongoDB, and MySQL. Experienced in cloud platforms, REST API development, payment integrations, AI solutions, Docker, and CI/CD pipelines.",
  resumeLink:
    "https://drive.google.com/file/d/1zqJtKo1nEkgONAQI3kF5EHZZKBRiPMBG/view?usp=sharing",
  portfolio_repository: "",
  githubProfile: "",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "LinkedIn",
    link: "https://in.linkedin.com/in/janak-koradiya-185284207",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:janakkoradiya.dev@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Phone",
    link: "tel:+917405336072",
    fontAwesomeIcon: "fa-phone", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "green", // Reference https://simpleicons.org/?q=gmail
  }
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      "skills": [
        "⚡ Building scalable web applications using React.js, Next.js, TypeScript, Redux, and RTK Query",
        "⚡ Developing RESTful APIs and microservices with Node.js, Express.js, and NestJS",
        "⚡ Designing and integrating secure authentication, payment, and third-party API solutions",
        "⚡ Building AI-powered, FinTech, SaaS, and enterprise applications with modern web technologies",
        "⚡ Optimizing application performance, database queries, and user experience"
      ],
      softwareSkills: [
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Node.js",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Express.js",
          fontAwesomeClassname: "skill-icons:expressjs-dark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Next.js",
          fontAwesomeClassname: "devicon:nextjs",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Vite.js",
          fontAwesomeClassname: "logos:vitejs",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NestJS",
          fontAwesomeClassname: "logos:nestjs",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Redux",
          fontAwesomeClassname: "simple-icons:redux",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Stripe",
          fontAwesomeClassname: "logos:stripe"
        },
        {
          skillName: "OpenAI",
          fontAwesomeClassname: "simple-icons:openai"
        },
        {
          skillName: "Plaid",
          fontAwesomeClassname: ""
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "mdi:git"
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "skill-icons:postman"
        }
      ],
    },
    {
      title: "Cloud & Deployment",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Deploying and managing applications on AWS, Azure, Vercel, Netlify, and Heroku",
        "⚡ Working with AWS EC2, Amplify, S3, and Azure Virtual Machines",
        "⚡ Managing MongoDB Atlas and MySQL databases in production environments",
        "⚡ Containerizing applications using Docker and supporting CI/CD deployment workflows",
        "⚡ Monitoring, troubleshooting, and optimizing cloud-hosted applications"
      ],
      softwareSkills: [

        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "lineicons:azure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "skill-icons:mysql-dark",
          style: {
            color: "#2c5a81",
          },
        },
        {
          skillName: "Vercel",
          fontAwesomeClassname: "skill-icons:vercel-dark",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "material-icon-theme:netlify-light",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "devicon-plain:heroku-wordmark",
          style: {
            color: "#6762a6",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        }
      ],
    }
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/layman_brother/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/ashutosh_1919",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@ashutosh391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Som-Lalit Institute of Computer Application, Ahmedabad",
      subtitle: "Bachelor of Computer Applications (BCA)",
      university: "Gujarat University",
      logo_path: "SLICA-removebg-preview.png",
      alt_name: "Som-Lalit Institute of Computer Applications",
      duration: "2016 - 2019",
      cgpa: "7.62/10",
      descriptions: [
        "⚡ Built a strong foundation in programming, database management, software engineering, and computer science fundamentals.",
        "⚡ Developed web-based applications and academic projects using modern programming concepts and technologies.",
        "⚡ Strengthened analytical thinking, problem-solving, and software development skills through practical assignments and projects."
      ],
      website_link: "https://www.somlalitcollege.org/bca/",
    },
    {
      title: "Government MCA College, Ahmedabad",
      subtitle: "Master of Computer Applications (MCA)",
      university: "Gujarat Technological University",
      logo_path: "gmca-removebg-preview.png",
      alt_name: "Government MCA College",
      duration: "2019 - 2022",
      cgpa: "8.67/10",
      descriptions: [
        "⚡ Specialized in Full Stack Development, Software Architecture, Database Systems, and Cloud Computing.",
        "⚡ Worked on industry-oriented projects involving web application development, system design, and scalable software solutions.",
        "⚡ Graduated with distinction and gained practical experience in modern development technologies and best practices."
      ],
      website_link: "https://www.gmca.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work & Internship",
  description:
    "Full Stack Developer with 4+ years of experience building scalable SaaS, FinTech, AI-powered, and enterprise applications using React.js, Next.js, Node.js, NestJS, and TypeScript. Experienced in API development, cloud deployment, payment integrations, database design, and modern web technologies.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Full Stack Developer",
          company: "Ordex Technology Solutions",
          company_url: "https://www.ordextechnology.com/",
          logo_path: "Ordex-removebg.png",
          duration: "July 2022 - Present",
          location: "Ahmedabad, Gujarat",
          description:
            "Delivered 12+ production-ready web applications across FinTech, AI, SaaS, Enterprise, and E-commerce domains. Developed scalable REST APIs and backend services using Node.js, NestJS, and Express.js. Integrated third-party services including Stripe, Plaid, Razorpay, OpenAI, and DocuSign. Built AI-powered workflows for document processing, lending automation, and financial analysis. Deployed and maintained cloud applications on AWS, Azure, Vercel, and Netlify.",
          color: "#000000",
        }
      ],
    },
    {
      title: "Internship",
      experiences: [
        {
          title: "MERN Stack Developer Intern",
          company: "Ordex Technology Solutions",
          company_url: "https://www.ordextechnology.com/",
          logo_path: "Ordex-removebg.png",
          duration: "Jan 2022 - June 2022",
          location: "Ahmedabad, Gujarat",
          description:
            "Worked on full-stack web applications using React.js, Node.js, Express.js, and MongoDB. Developed REST APIs, integrated databases, collaborated on frontend and backend features, and gained hands-on experience with cloud deployment and production application development.",
          color: "#000000",
        }
      ],
    }
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I have worked on various projects leveraging modern technologies. My expertise lies in building and deploying web applications using MERN stack and cloud platforms like AWS and Azure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
    {
      id: "mdp-diffusion",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/mdp-diffusion/",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/consistency-models/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "profile-picture.png",
    description:
      "I am available on Gmail and various social media platforms. Feel free to reach out for discussions on MERN stack development and cloud deployments (AWS & Azure). I usually respond within 24 hours.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Nikol, Ahmedabad, Gujarat, India - 382350",
    locality: "Ahmedabad",
    country: "India",
    region: "Gujarat",
    postalCode: "382350",
    streetAddress: "Nikol",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/iVxkgnczJB9oQ4KSA",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
